import { get } from 'lodash';

import { getAuthors } from './getAuthors';
import { getContentTaxonomy } from './getContentTaxonomy';
import { translateItemTypesName } from '../ExerciseUtils';
import { getAbsolutePathforImageAndAudio } from './utilsForImageAndAudioPath';

export const fixExerciseStructure = exercise => ({
    book: {
        id: exercise.bookId,
        authors: getAuthors(exercise),
        title: exercise.bookTitle
    },
    contextId: exercise.contextId,
    ...(exercise.difficulty && { difficulty: exercise.difficulty }),
    ...(exercise.filteringBooks && { filteringBooks: exercise.filteringBooks }),
    id: exercise.id,
    isPreviewOpen: false,
    ...(exercise.sharedtextNodeId && { sharedtextNodeId: exercise.sharedtextNodeId }),
    ...(exercise.sharedTextXml && { sharedTextXml: getAbsolutePathforImageAndAudio(exercise.sharedTextXml) }),
    ...(exercise.audioNodeId && { audioNodeId: exercise.audioNodeId }),
    ...(exercise.audioXml && { audioXml: getAbsolutePathforImageAndAudio(exercise.audioXml) }),
    relatedItemsCount: exercise.relatedCount || null,
    subject: get(exercise, 'subjects[0]', {}),
    taxonomy: getContentTaxonomy(exercise.contentPaths),
    title: exercise.publicTitle || null,
    invalsiInfo: exercise.invalsiInfo || null,
    originName: exercise.originName || null,
    type: {
        id: exercise.type || null,
        label: (exercise.typeLabel && translateItemTypesName(exercise.typeLabel)) || null
    },
    UGC: exercise.UGC || false,
    xml: getAbsolutePathforImageAndAudio(exercise.xml)
});
